import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { ChevronDown, ChevronUp } from "lucide-react";

const ServiceArea = [
  { label: "Güneşli Koltuk Yıkama", path: "/bagcilar/gunesli-koltuk-yikama" },
  { label: "Güneşli Yatak Yıkama", path: "/bagcilar/gunesli-yatak-yikama" },
  { label: "Yenigün Koltuk Yıkama", path: "/bagcilar/yenigun-koltuk-yikama" },
  { label: "Yenigün Kuru Temizleme", path: "/bagcilar/yenigun-kuru-temizleme" },
  { label: "100. Yıl Mahallesi Koltuk Yıkama", path: "/bagcilar/100-yil-koltuk-yikama" },
  { label: "100. Yıl Mahallesi Battaniye Yıkama", path: "/bagcilar/100-yil-battaniye-yikama" },
  { label: "Mahmutbey Koltuk Yıkama", path: "/bagcilar/mahmutbey-koltuk-yikama" },
  { label: "Mahmutbey Perde Yıkama", path: "/bagcilar/mahmutbey-perde-yikama" },
  { label: "Kirazlı Koltuk Yıkama", path: "/bagcilar/kirazli-koltuk-yikama" },
  { label: "Kirazlı Yorgan Yıkama", path: "/bagcilar/kirazli-yorgan-yikama" },
  { label: "Bağcılar Merkez Koltuk Yıkama", path: "/bagcilar/merkez-koltuk-yikama" }
];

const BagcilarServiceArea = () => {
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="text-[#003132] mt-0 w-full">
      <div
        onClick={toggleDropdown}
        className="cursor-pointer flex items-center justify-between bg-[#e2e8f0] p-3 rounded-lg shadow-md hover:bg-[#d1d5db]"
      >
        <h2 className="text-lg font-semibold uppercase tracking-wide">
          BAĞCILAR HİZMET TÜRLERİ
        </h2>
        {isOpen ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
      </div>

      {isOpen && (
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-2 gap-3 bg-[#f1f5f9] p-5 rounded-xl shadow-sm border border-gray-200 w-full mt-2">
          {ServiceArea.map((area, index) => (
            <Link
              key={index}
              to={area.path}
              className={`text-sm font-semibold px-4 py-3 rounded-lg text-center transition-all duration-200 ${
                location.pathname === area.path
                  ? "bg-green-700 text-white"
                  : "bg-white text-green-900 hover:bg-green-100 hover:text-green-800"
              }`}
            >
              {area.label}
            </Link>
          ))}
        </div>
      )}
    </div>
  );
};

export default BagcilarServiceArea;
